var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtntickettoclient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#FF8001"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6673 27.5V25.8333C26.6673 24.9493 26.3161 24.1014 25.691 23.4763C25.0659 22.8512 24.218 22.5 23.334 22.5H16.6673C15.7833 22.5 14.9354 22.8512 14.3103 23.4763C13.6852 24.1014 13.334 24.9493 13.334 25.8333V27.5M23.334 15.8333C23.334 17.6743 21.8416 19.1667 20.0007 19.1667C18.1597 19.1667 16.6673 17.6743 16.6673 15.8333C16.6673 13.9924 18.1597 12.5 20.0007 12.5C21.8416 12.5 23.334 13.9924 23.334 15.8333Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtntickettoclient);
export default __webpack_public_path__ + "static/media/btntickettoclient.24a66d3cb010c472b9a00927a394bbbb.svg";
export { ForwardRef as ReactComponent };